import moment from "moment";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../api/firebase/references";
import { MedicationListItem } from "../data-model/medicationListModel";

/**
 * Persist the full medications array back to the medication-list document.
 * Uses the same Firestore path that fetchDrugConfigfromFirebase reads from.
 */
export const saveMedicationList = async (
  _organization: string,
  medications: MedicationListItem[],
): Promise<string> => {
  const lastSync = moment().toDate().toISOString();
  const docPath = FirestoreDocumentReference.drugsConfigurationPath();
  const collectionPath = docPath.substring(0, docPath.lastIndexOf("/"));
  const docId = docPath.substring(docPath.lastIndexOf("/") + 1);
  await FirestoreService.setDocument(collectionPath, docId, {
    medications,
    total_count: medications.length,
    last_sync: lastSync,
  });
  return lastSync;
};
